import * as z from "zod";

import { validAreaCodes } from "./areacodes";

// Constants
export const BUSINESS_ROLES = [
  "ceo",
  "manager",
  "accountant",
  "vice_president",
] as const;

export const EMPLOYMENT_TYPES = ["owner", "employee"] as const;

export const WithPhoneNumber = z.object({
  phone_number: z
    .string()
    .refine((value) => value.replace(/\D/g, "").length === 11, {
      message: "Please enter a valid phone number",
    })
    .refine(
      (value) => {
        const areaCode = value.replace(/\D/g, "").slice(1, 4);
        return validAreaCodes.includes(areaCode);
      },
      {
        message: "Area code is not valid",
      }
    )
    .transform((value) => {
      // Remove non-numeric characters except for the leading '+'
      return value.replace(/[^\d+]/g, "");
    }),
});

const STATE_CODES = [
  "AL",
  "AK",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
  "AS",
  "GU",
  "MP",
  "PR",
  "UM",
  "VI",
  "FM",
  "MH",
  "PW",
  "AA",
  "AE",
  "AP",
];

export const WithAutocompleteAddress = z.object({
  address_1: z
    .string()
    .min(1, { message: "Please select an address from the dropdown" }),
  address_2: z.string().optional(),
  city: z.string().min(1),
  state: z
    .string()
    .min(1)
    .max(2, { message: "State should be a 2 character code" })
    .transform((value) => value.toUpperCase())
    .refine(
      (value) => {
        return STATE_CODES.includes(value);
      },
      { message: "State code is not valid" }
    ),
  zip: z
    .string()
    .min(1)
    .regex(/^\d{5}(-\d{4})?$/, "Invalid ZIP code"),
});
